module.exports = __webpack_public_path__ + "static/img/banner-img.9b02e9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serviceCenter/banner-img.png
// module id = JiBH
// module chunks = 44